// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Grid Layout */
.container_RCCXj {
  display: flex;
  gap: 10px;
  flex-direction: column;
  transition: all 0.3s ease;
}

.container_RCCXj.expanded_Auoz9 {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  background: white;
  padding: 10px;
  flex-direction: row;
  gap: 10px;
}

.expandedApp {
  [class^="chatTextContainer"] {
    position: fixed;
    bottom: 10px;
    width: calc(100% - 254px);
    background: #fff;
    left: unset;
    z-index: 9999;
    top: unset;
    right: 10px;
    height: 160px;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    transition: width 0.3s ease, height 0.3s ease;
    
    [class^="chatTextAreaContainer"] {
      max-width: unset;
      width: 100%;
      height: 100%;
      background: transparent;
      margin: 0px;
      border-radius: 0px;
      justify-content: space-between;
      transition: all 0.3s ease;
      padding: 1px;
      overflow: hidden;
    }

    [class^="chatRecorder"] {
      max-width: unset;
      margin: 0px;
      width: 100%;
      border-radius: 0px !important;
      padding: 0px;
      [class^="chatRecorder"] {
        margin-left: 10px;
      }
    }
    
    [class^="errorAlert"] {
      display: none;
    }
  }
}

/* File Explorer Sidebar */
.sidebar_hrLnL {
  overflow: hidden;
  background-color: white;
  display: flex;
  flex-direction: column;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  z-index: 5 !important;
  position: fixed !important;
  top: unset !important;
  bottom: 260px;
  right: 20px;
  min-height: 40px;
  max-height: 400px;
  width: 220px;
}

.container_RCCXj.expanded_Auoz9 .sidebar_hrLnL {
  max-width: 220px;
  min-width: 220px;
  position: relative !important;
  top: unset !important;
  right: unset !important;
  max-height: unset !important;
  bottom: unset !important;
}

.container_RCCXj.expanded_Auoz9 .folderIndicator_Yc_4l {
  display: none !important;
}

/* Project Selector */
.projectSelector_tQcMD {
  padding: 1rem;
  border-bottom: 1px solid #e5e7eb;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
}

.projectTitle__jnuT {
  margin: 0 0 0.75rem 0;
  font-size: 1rem;
  font-weight: 600;
  color: #374151;
}

.projectSelect_LYEA4 {
  width: 100%;
  padding: 0.5rem;
  border: 2px solid #e5e7eb;
  border-radius: 6px;
  background: white;
  color: #374151;
  font-size: 0.875rem;
  cursor: pointer;
  transition: border-color 0.2s ease;
}

.projectSelect_LYEA4:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.projectSelect_LYEA4:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.projectDescription_o1Qlt {
  margin: 0.5rem 0 0 0;
  font-size: 0.75rem;
  color: #6b7280;
  line-height: 1.4;
}

.sidebarActions_VsIHS {
  display: flex;
  gap: 4px;
}

/* Buttons */
.btn_GwyUB {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  border-radius: 0.25rem;
  border: none;
  cursor: pointer;
  transition: background-color 0.2s;
  white-space: nowrap;
}

.btn_GwyUB:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btnPrimary_Aradl {
  background-color: #3b82f6;
  color: white;
}

.btnPrimary_Aradl:hover:not(:disabled) {
  background-color: #2563eb;
}

.btnSuccess_syL9s {
  background-color: #10b981;
  color: white;
}

.btnSuccess_syL9s:hover:not(:disabled) {
  background-color: #059669;
}

.btnPurple_zUY_6 {
  background-color: #8b5cf6;
  color: white;
}

.btnPurple_zUY_6:hover:not(:disabled) {
  background-color: #7c3aed;
}

.btnGray_cjciZ {
  background-color: #6b7280;
  color: white;
}

.btnGray_cjciZ:hover:not(:disabled) {
  background-color: #4b5563;
}

.btnRed_gVsH6 {
  background-color: #ef4444;
  color: white;
}

.btnRed_gVsH6:hover:not(:disabled) {
  background-color: #dc2626;
}

/* Nuevos botones */
.btnCss_ZVE6D {
  background-color: #06b6d4;
  color: white;
}

.btnCss_ZVE6D:hover:not(:disabled) {
  background-color: #0891b2;
}

.btnJs_mn7Qk {
  background-color: #f59e0b;
  color: white;
}

.btnJs_mn7Qk:hover:not(:disabled) {
  background-color: #d97706;
}

.btnCopy_tMrKX {
  background-color: #6b7280;
  color: white;
}

.btnCopy_tMrKX:hover:not(:disabled) {
  background-color: #4b5563;
}

.hidden_ZzPi5 {
  opacity: 0 !important;
  visibility: hidden !important;
  transform: scale(0.8) !important;
  pointer-events: none !important;
  transition: opacity 0.2s ease, visibility 0.2s ease, transform 0.2s ease !important;
}

.btnShowMore_lgQ2h,
.btnShowLess_t9dUb {
  background-color: transparent;
  color: #374151;
  border: 1px solid #e5e9ef;
  margin-top: 0.5rem;
  width: 100%;
  /* border: none; */
  border-radius: 0px;
  border-left: none;
  border-right: none;
}

.btnShowMore_lgQ2h:hover:not(:disabled),
.btnShowLess_t9dUb:hover:not(:disabled) {
  background-color: #e5e7eb;
}

.editorContainer_5GyO3 {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

/* File List */
.fileList_wtaMt {
  padding: 0.5rem;
}

.fileList_wtaMt ul {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.fileItem_aV_LJ {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.fileItem_aV_LJ:hover .deleteBtn_BJIEm {
  opacity: 1;
}

.fileContent_qiO22 {
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 0.25rem;
  flex: 1 1;
  display: flex;
  align-items: center;
}

.fileContent_qiO22:hover {
  background-color: #f3f4f6;
}

.fileContent_qiO22.selected_Wd13w {
  background-color: #dbeafe;
  color: #1e40af;
  font-weight: 600;
}

.fileIcon_WC_qR {
  margin-right: 0.5rem;
}

.deleteBtn_BJIEm {
  opacity: 0;
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  background-color: #ef4444;
  color: white;
  border: none;
  border-radius: 0.25rem;
  cursor: pointer;
  transition: opacity 0.2s, background-color 0.2s;
}

.deleteBtn_BJIEm:hover:not(:disabled) {
  background-color: #dc2626;
}

/* Editor Section */
.editor_ZQKPv {
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.3s ease;
  z-index: 2;
  flex: 1 1;
}

.container_RCCXj.expanded_Auoz9 .editor_ZQKPv {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 190px);
}

.editorExpanded_h5ibt {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 120px);
}

.editorHeader_M2E5T {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 10px;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border-bottom: 1px solid #e5e7eb;
}

.editorTitle_kSv4l {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 600;
  color: #374151;
}

.fileIcon_WC_qR {
  font-size: 1.125rem;
}

.editorPath__cV3j {
  font-size: 0.875rem;
}

.titleInput_gkTKx {
  font-size: 0.875rem;
  font-weight: 600;
  color: #374151;
  background: transparent;
  border: none;
  outline: none;
  border-bottom: 2px solid #3b82f6;
  padding: 2px 0;
  min-width: 100px;
}

.editorActions_DKrc2 {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}

/* Textarea and Code Display */
.editorTextarea_ZEsH1 {
  width: 100%;
  min-height: 200px;
  padding: 1rem;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
  font-size: 0.875rem;
  line-height: 1.5;
  resize: vertical;
  background-color: #f9fafb;
  color: #1f2937;
  transition: border-color 0.2s;
}

.editorTextarea_ZEsH1:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.editorTextarea_ZEsH1:disabled {
  background-color: #f3f4f6;
  color: #6b7280;
  cursor: not-allowed;
}

.codeDisplay_DU5D2 {
  background-color: #fff;
  border-radius: 0.375rem;
  padding: 1rem;
  overflow-x: auto;
  white-space: pre-wrap;
  word-break: break-word;

}

.codeDisplayContainer_yKQuQ {
  position: relative;
  height: 100%;
  transition: all 0.2s ease;
}

/* .codeDisplayContainer:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
} */

/* Estilos para Monaco Editor en modo expandido */
.container_RCCXj.expanded_Auoz9 .editor_ZQKPv .monacoContainer_YxrVG {
  height: calc(100vh - 180px);
  min-height: 400px;
}

.editorHint_jh39_ {
  margin-top: 0.5rem;
  font-size: 0.75rem;
  color: #6b7280;
  text-align: center;
  font-style: italic;
}

/* Preview/Base64 Section */
.preview_Tgb0_ {
  background-color: white;
  z-index: 5;
  position: sticky;
  top: 0;
  /* height: 0px; */
}

.previewHeader_PrPwJ {
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* padding: 0.75rem 1rem; */
  /* border-bottom: 1px solid #e5e7eb; */
}

.previewTitle_kQl44 {
  margin: 0;
  font-size: 0.875rem;
  font-weight: 600;
  color: #374151;
}

.previewContent_EJSSy {
  height: 100%;
  overflow: auto;
  padding: 1rem;
}

.previewCode_XZCuE {
  font-size: 0.75rem;
  background-color: #f3f4f6;
  padding: 0.5rem;
  border-radius: 0.25rem;
}

.base64Textarea_OeYra {
  width: 100%;
  height: 100%;
  border: none;
  padding: 2px;
  resize: none;
  font-family: inherit;
}

/* Responsive adjustments */
@media (max-width: 1024px) {
  .container_RCCXj {
    flex-direction: column;
    gap: 10px;
  }

  .container_RCCXj.expanded_Auoz9 {
    flex-direction: column;
    gap: 10px;
  }

  .sidebar_hrLnL {
    min-width: auto;
    max-width: none;
  }

  .container_RCCXj.expanded_Auoz9 .sidebar_hrLnL {
    flex: none;
    max-width: none;
    min-width: auto;
  }

  .editor_ZQKPv {
    flex: 1 1;
  }

  .container_RCCXj.expanded_Auoz9 .editor_ZQKPv {
    flex: 1 1;
  }

  .preview_Tgb0_ {
    background-color: white;
    z-index: 5;
    position: sticky;
    top: 0;
    height: 0px;
    overflow: unset;
  }
}

@media (max-width: 768px) {
  .container_RCCXj.expanded_Auoz9 {
    padding: 10px;
  }

  .editorHeader_M2E5T {
    padding: 4px 8px;
  }

  .editorActions_DKrc2 {
    gap: 0.25rem;
  }

  .btn_GwyUB {
    padding: 0.25rem;
    font-size: 0.75rem;
  }

  .sidebarActions_VsIHS {
    gap: 0.25rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/ChatView/FileExplorer/FileExplorer.module.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,aAAa;EACb,SAAS;EACT,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE;IACE,eAAe;IACf,YAAY;IACZ,yBAAyB;IACzB,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,UAAU;IACV,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,6CAA6C;;IAE7C;MACE,gBAAgB;MAChB,WAAW;MACX,YAAY;MACZ,uBAAuB;MACvB,WAAW;MACX,kBAAkB;MAClB,8BAA8B;MAC9B,yBAAyB;MACzB,YAAY;MACZ,gBAAgB;IAClB;;IAEA;MACE,gBAAgB;MAChB,WAAW;MACX,WAAW;MACX,6BAA6B;MAC7B,YAAY;MACZ;QACE,iBAAiB;MACnB;IACF;;IAEA;MACE,aAAa;IACf;EACF;AACF;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,0BAA0B;EAC1B,qBAAqB;EACrB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,qBAAqB;EACrB,uBAAuB;EACvB,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,gCAAgC;EAChC,6DAA6D;AAC/D;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA,YAAY;AACZ;EACE,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,mBAAmB;AACnB;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,gCAAgC;EAChC,+BAA+B;EAC/B,mFAAmF;AACrF;;AAEA;;EAEE,6BAA6B;EAC7B,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA,cAAc;AACd;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,SAAO;EACP,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,+CAA+C;AACjD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,UAAU;EACV,SAAO;AACT;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,6DAA6D;EAC7D,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,gCAAgC;EAChC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,uBAAuB;EACvB,wDAAwD;EACxD,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;;AAExB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;;GAEG;;AAEH,iDAAiD;AACjD;EACE,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE,uBAAuB;EACvB,UAAU;EACV,gBAAgB;EAChB,MAAM;EACN,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,oBAAoB;AACtB;;AAEA,2BAA2B;AAC3B;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,uBAAuB;IACvB,UAAU;IACV,gBAAgB;IAChB,MAAM;IACN,WAAW;IACX,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;AACF","sourcesContent":["/* Grid Layout */\n.container {\n  display: flex;\n  gap: 10px;\n  flex-direction: column;\n  transition: all 0.3s ease;\n}\n\n.container.expanded {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 9999;\n  background: white;\n  padding: 10px;\n  flex-direction: row;\n  gap: 10px;\n}\n\n:global(.expandedApp) {\n  [class^=\"chatTextContainer\"] {\n    position: fixed;\n    bottom: 10px;\n    width: calc(100% - 254px);\n    background: #fff;\n    left: unset;\n    z-index: 9999;\n    top: unset;\n    right: 10px;\n    height: 160px;\n    border: 1px solid #e5e7eb;\n    border-radius: 8px;\n    transition: width 0.3s ease, height 0.3s ease;\n    \n    [class^=\"chatTextAreaContainer\"] {\n      max-width: unset;\n      width: 100%;\n      height: 100%;\n      background: transparent;\n      margin: 0px;\n      border-radius: 0px;\n      justify-content: space-between;\n      transition: all 0.3s ease;\n      padding: 1px;\n      overflow: hidden;\n    }\n\n    [class^=\"chatRecorder\"] {\n      max-width: unset;\n      margin: 0px;\n      width: 100%;\n      border-radius: 0px !important;\n      padding: 0px;\n      [class^=\"chatRecorder\"] {\n        margin-left: 10px;\n      }\n    }\n    \n    [class^=\"errorAlert\"] {\n      display: none;\n    }\n  }\n}\n\n/* File Explorer Sidebar */\n.sidebar {\n  overflow: hidden;\n  background-color: white;\n  display: flex;\n  flex-direction: column;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  z-index: 5 !important;\n  position: fixed !important;\n  top: unset !important;\n  bottom: 260px;\n  right: 20px;\n  min-height: 40px;\n  max-height: 400px;\n  width: 220px;\n}\n\n.container.expanded .sidebar {\n  max-width: 220px;\n  min-width: 220px;\n  position: relative !important;\n  top: unset !important;\n  right: unset !important;\n  max-height: unset !important;\n  bottom: unset !important;\n}\n\n.container.expanded .folderIndicator {\n  display: none !important;\n}\n\n/* Project Selector */\n.projectSelector {\n  padding: 1rem;\n  border-bottom: 1px solid #e5e7eb;\n  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);\n}\n\n.projectTitle {\n  margin: 0 0 0.75rem 0;\n  font-size: 1rem;\n  font-weight: 600;\n  color: #374151;\n}\n\n.projectSelect {\n  width: 100%;\n  padding: 0.5rem;\n  border: 2px solid #e5e7eb;\n  border-radius: 6px;\n  background: white;\n  color: #374151;\n  font-size: 0.875rem;\n  cursor: pointer;\n  transition: border-color 0.2s ease;\n}\n\n.projectSelect:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.projectSelect:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.projectDescription {\n  margin: 0.5rem 0 0 0;\n  font-size: 0.75rem;\n  color: #6b7280;\n  line-height: 1.4;\n}\n\n.sidebarActions {\n  display: flex;\n  gap: 4px;\n}\n\n/* Buttons */\n.btn {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.75rem;\n  border-radius: 0.25rem;\n  border: none;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  white-space: nowrap;\n}\n\n.btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.btnPrimary {\n  background-color: #3b82f6;\n  color: white;\n}\n\n.btnPrimary:hover:not(:disabled) {\n  background-color: #2563eb;\n}\n\n.btnSuccess {\n  background-color: #10b981;\n  color: white;\n}\n\n.btnSuccess:hover:not(:disabled) {\n  background-color: #059669;\n}\n\n.btnPurple {\n  background-color: #8b5cf6;\n  color: white;\n}\n\n.btnPurple:hover:not(:disabled) {\n  background-color: #7c3aed;\n}\n\n.btnGray {\n  background-color: #6b7280;\n  color: white;\n}\n\n.btnGray:hover:not(:disabled) {\n  background-color: #4b5563;\n}\n\n.btnRed {\n  background-color: #ef4444;\n  color: white;\n}\n\n.btnRed:hover:not(:disabled) {\n  background-color: #dc2626;\n}\n\n/* Nuevos botones */\n.btnCss {\n  background-color: #06b6d4;\n  color: white;\n}\n\n.btnCss:hover:not(:disabled) {\n  background-color: #0891b2;\n}\n\n.btnJs {\n  background-color: #f59e0b;\n  color: white;\n}\n\n.btnJs:hover:not(:disabled) {\n  background-color: #d97706;\n}\n\n.btnCopy {\n  background-color: #6b7280;\n  color: white;\n}\n\n.btnCopy:hover:not(:disabled) {\n  background-color: #4b5563;\n}\n\n.hidden {\n  opacity: 0 !important;\n  visibility: hidden !important;\n  transform: scale(0.8) !important;\n  pointer-events: none !important;\n  transition: opacity 0.2s ease, visibility 0.2s ease, transform 0.2s ease !important;\n}\n\n.btnShowMore,\n.btnShowLess {\n  background-color: transparent;\n  color: #374151;\n  border: 1px solid #e5e9ef;\n  margin-top: 0.5rem;\n  width: 100%;\n  /* border: none; */\n  border-radius: 0px;\n  border-left: none;\n  border-right: none;\n}\n\n.btnShowMore:hover:not(:disabled),\n.btnShowLess:hover:not(:disabled) {\n  background-color: #e5e7eb;\n}\n\n.editorContainer {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n/* File List */\n.fileList {\n  padding: 0.5rem;\n}\n\n.fileList ul {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.fileItem {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.fileItem:hover .deleteBtn {\n  opacity: 1;\n}\n\n.fileContent {\n  cursor: pointer;\n  padding: 0.5rem;\n  border-radius: 0.25rem;\n  flex: 1;\n  display: flex;\n  align-items: center;\n}\n\n.fileContent:hover {\n  background-color: #f3f4f6;\n}\n\n.fileContent.selected {\n  background-color: #dbeafe;\n  color: #1e40af;\n  font-weight: 600;\n}\n\n.fileIcon {\n  margin-right: 0.5rem;\n}\n\n.deleteBtn {\n  opacity: 0;\n  padding: 0.25rem 0.5rem;\n  font-size: 0.75rem;\n  background-color: #ef4444;\n  color: white;\n  border: none;\n  border-radius: 0.25rem;\n  cursor: pointer;\n  transition: opacity 0.2s, background-color 0.2s;\n}\n\n.deleteBtn:hover:not(:disabled) {\n  background-color: #dc2626;\n}\n\n/* Editor Section */\n.editor {\n  background: white;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  overflow: hidden;\n  transition: all 0.3s ease;\n  z-index: 2;\n  flex: 1;\n}\n\n.container.expanded .editor {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  height: calc(100vh - 190px);\n}\n\n.editorExpanded {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  height: calc(100vh - 120px);\n}\n\n.editorHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 6px 10px;\n  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.editorTitle {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-weight: 600;\n  color: #374151;\n}\n\n.fileIcon {\n  font-size: 1.125rem;\n}\n\n.editorPath {\n  font-size: 0.875rem;\n}\n\n.titleInput {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: #374151;\n  background: transparent;\n  border: none;\n  outline: none;\n  border-bottom: 2px solid #3b82f6;\n  padding: 2px 0;\n  min-width: 100px;\n}\n\n.editorActions {\n  display: flex;\n  gap: 0.5rem;\n  align-items: center;\n}\n\n/* Textarea and Code Display */\n.editorTextarea {\n  width: 100%;\n  min-height: 200px;\n  padding: 1rem;\n  border: 1px solid #d1d5db;\n  border-radius: 0.375rem;\n  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  resize: vertical;\n  background-color: #f9fafb;\n  color: #1f2937;\n  transition: border-color 0.2s;\n}\n\n.editorTextarea:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.editorTextarea:disabled {\n  background-color: #f3f4f6;\n  color: #6b7280;\n  cursor: not-allowed;\n}\n\n.codeDisplay {\n  background-color: #fff;\n  border-radius: 0.375rem;\n  padding: 1rem;\n  overflow-x: auto;\n  white-space: pre-wrap;\n  word-break: break-word;\n\n}\n\n.codeDisplayContainer {\n  position: relative;\n  height: 100%;\n  transition: all 0.2s ease;\n}\n\n/* .codeDisplayContainer:hover {\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n} */\n\n/* Estilos para Monaco Editor en modo expandido */\n.container.expanded .editor .monacoContainer {\n  height: calc(100vh - 180px);\n  min-height: 400px;\n}\n\n.editorHint {\n  margin-top: 0.5rem;\n  font-size: 0.75rem;\n  color: #6b7280;\n  text-align: center;\n  font-style: italic;\n}\n\n/* Preview/Base64 Section */\n.preview {\n  background-color: white;\n  z-index: 5;\n  position: sticky;\n  top: 0;\n  /* height: 0px; */\n}\n\n.previewHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  /* padding: 0.75rem 1rem; */\n  /* border-bottom: 1px solid #e5e7eb; */\n}\n\n.previewTitle {\n  margin: 0;\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: #374151;\n}\n\n.previewContent {\n  height: 100%;\n  overflow: auto;\n  padding: 1rem;\n}\n\n.previewCode {\n  font-size: 0.75rem;\n  background-color: #f3f4f6;\n  padding: 0.5rem;\n  border-radius: 0.25rem;\n}\n\n.base64Textarea {\n  width: 100%;\n  height: 100%;\n  border: none;\n  padding: 2px;\n  resize: none;\n  font-family: inherit;\n}\n\n/* Responsive adjustments */\n@media (max-width: 1024px) {\n  .container {\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .container.expanded {\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .sidebar {\n    min-width: auto;\n    max-width: none;\n  }\n\n  .container.expanded .sidebar {\n    flex: none;\n    max-width: none;\n    min-width: auto;\n  }\n\n  .editor {\n    flex: 1;\n  }\n\n  .container.expanded .editor {\n    flex: 1;\n  }\n\n  .preview {\n    background-color: white;\n    z-index: 5;\n    position: sticky;\n    top: 0;\n    height: 0px;\n    overflow: unset;\n  }\n}\n\n@media (max-width: 768px) {\n  .container.expanded {\n    padding: 10px;\n  }\n\n  .editorHeader {\n    padding: 4px 8px;\n  }\n\n  .editorActions {\n    gap: 0.25rem;\n  }\n\n  .btn {\n    padding: 0.25rem;\n    font-size: 0.75rem;\n  }\n\n  .sidebarActions {\n    gap: 0.25rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container_RCCXj`,
	"expanded": `expanded_Auoz9`,
	"sidebar": `sidebar_hrLnL`,
	"folderIndicator": `folderIndicator_Yc_4l`,
	"projectSelector": `projectSelector_tQcMD`,
	"projectTitle": `projectTitle__jnuT`,
	"projectSelect": `projectSelect_LYEA4`,
	"projectDescription": `projectDescription_o1Qlt`,
	"sidebarActions": `sidebarActions_VsIHS`,
	"btn": `btn_GwyUB`,
	"btnPrimary": `btnPrimary_Aradl`,
	"btnSuccess": `btnSuccess_syL9s`,
	"btnPurple": `btnPurple_zUY_6`,
	"btnGray": `btnGray_cjciZ`,
	"btnRed": `btnRed_gVsH6`,
	"btnCss": `btnCss_ZVE6D`,
	"btnJs": `btnJs_mn7Qk`,
	"btnCopy": `btnCopy_tMrKX`,
	"hidden": `hidden_ZzPi5`,
	"btnShowMore": `btnShowMore_lgQ2h`,
	"btnShowLess": `btnShowLess_t9dUb`,
	"editorContainer": `editorContainer_5GyO3`,
	"fileList": `fileList_wtaMt`,
	"fileItem": `fileItem_aV_LJ`,
	"deleteBtn": `deleteBtn_BJIEm`,
	"fileContent": `fileContent_qiO22`,
	"selected": `selected_Wd13w`,
	"fileIcon": `fileIcon_WC_qR`,
	"editor": `editor_ZQKPv`,
	"editorExpanded": `editorExpanded_h5ibt`,
	"editorHeader": `editorHeader_M2E5T`,
	"editorTitle": `editorTitle_kSv4l`,
	"editorPath": `editorPath__cV3j`,
	"titleInput": `titleInput_gkTKx`,
	"editorActions": `editorActions_DKrc2`,
	"editorTextarea": `editorTextarea_ZEsH1`,
	"codeDisplay": `codeDisplay_DU5D2`,
	"codeDisplayContainer": `codeDisplayContainer_yKQuQ`,
	"monacoContainer": `monacoContainer_YxrVG`,
	"editorHint": `editorHint_jh39_`,
	"preview": `preview_Tgb0_`,
	"previewHeader": `previewHeader_PrPwJ`,
	"previewTitle": `previewTitle_kQl44`,
	"previewContent": `previewContent_EJSSy`,
	"previewCode": `previewCode_XZCuE`,
	"base64Textarea": `base64Textarea_OeYra`
};
export default ___CSS_LOADER_EXPORT___;
